module.exports = __webpack_public_path__ + "assets/img/15.a4946e50.png";